"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonSet_1 = require("../../../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var CardEditorContainer_1 = require("../../../../../../../../shared/components/containers/CardEditorContainer");
var CardRowButtonTextEditor_1 = require("../../../../../../../../shared/components/editors/CardRowButtonTextEditor");
var AffilateEMailTemplateImageEditor = /** @class */ (function (_super) {
    __extends(AffilateEMailTemplateImageEditor, _super);
    function AffilateEMailTemplateImageEditor(props) {
        return _super.call(this, props) || this;
    }
    AffilateEMailTemplateImageEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record != null) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    image_identity: _item.image_identity,
                    image_url: _item.image_url,
                    description: _item.description,
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Шаблоны П.Программы", "Изображения шаблона", "Редактирование изображения"]);
                });
            }
        }
        else {
            this.setState({
                image_identity: "",
                image_url: "",
                description: ""
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Шаблоны П.Программы", "Изображения шаблона", "Создание изображения"]);
            });
        }
        this.doReSetRules();
    };
    AffilateEMailTemplateImageEditor.prototype.doReSetRules = function () {
        this.setState({
            image_identity_rules: { isError: false },
            image_url_rules: { isError: false },
            description_rules: { isError: false }
        });
    };
    AffilateEMailTemplateImageEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.image_identity) || (this.state.image_identity.length === 0)) {
            this.setState({ image_identity_rules: { isError: true, errorMessage: "Поле [идентификатор изображения] не заполнено!" } });
            return false;
        }
        if ((!this.state.image_url) || (this.state.image_url.length === 0)) {
            this.setState({ image_url_rules: { isError: true, errorMessage: "Поле [url изображения] не заполнено!" } });
            return false;
        }
        return true;
    };
    AffilateEMailTemplateImageEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                email_set_template_id: this.props.rootRecord.key,
                image_identity: this.state.image_identity,
                description: this.state.description,
                image_url: this.state.image_url,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Изображение шаблона добавлено!");
            });
        }
    };
    AffilateEMailTemplateImageEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                image_identity: this.state.image_identity,
                image_url: this.state.image_url,
                description: this.state.description
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Изображение шаблона изменено!");
            });
        }
    };
    AffilateEMailTemplateImageEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    AffilateEMailTemplateImageEditor.prototype.getFormTitle = function () {
        if (this.props.record) {
            return "Новое изображение email шаблона";
        }
        else {
            return "Изменить изображение email шаблона";
        }
    };
    AffilateEMailTemplateImageEditor.prototype.DoShowSelectImageDialog = function () {
        var _this = this;
        this.props.dialogSelectImage.SetDialogTitle("Выбор изображения").SetOnSelect(function (brandIdentity, dirName, fileName) {
            _this.setState({ image_url: brandIdentity + "/" + dirName + "/" + fileName }, function () {
                _this.props.dialogSelectImage.Close();
            });
        }).Show();
    };
    AffilateEMailTemplateImageEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 350 },
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "ID изображения:", placeholder: "Введите идентификатор изображения" }, value: this.state.image_identity, onValueChanged: function (newVal) {
                    _this.setState({
                        image_identity: newVal,
                        image_identity_rules: { isError: false }
                    });
                }, required: true, rules: this.state.image_identity_rules }),
            React.createElement(CardRowButtonTextEditor_1.default, { texts: {
                    caption: "Изображение:",
                    placeholder: "Выберите изображение",
                    buttonHint: "Выберите изображение"
                }, readonly: true, onButtonClick: this.DoShowSelectImageDialog.bind(this), onValueChanged: function (newVal) {
                    _this.setState({
                        image_url: newVal,
                        image_url_rules: { isError: false }
                    });
                }, value: this.state.image_url, buttonIcon: "search", required: true, rules: this.state.image_url_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) {
                    _this.setState({
                        description: newVal
                    });
                } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return AffilateEMailTemplateImageEditor;
}(React.Component));
exports.default = AffilateEMailTemplateImageEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_pprograms_list/ui/component/config/email/AffilateEmailTemplateImageEditor.tsx
// module id = 2035
// module chunks = 0